var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "input-group" }, [
          _vm._m(0),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.itemMatched,
                expression: "itemMatched"
              }
            ],
            staticClass: "form-control",
            attrs: { placeholder: _vm.placeholder, type: "text" },
            domProps: { value: _vm.itemMatched },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.itemMatched = $event.target.value
              }
            }
          })
        ])
      ])
    ]),
    _c("div", { staticClass: "panel overflow-auto border" }, [
      _c(
        "div",
        { staticClass: "row mx-1" },
        _vm._l(_vm.itemsMatched, function(item) {
          return _c(
            "div",
            {
              key: item.label,
              staticClass: "col-12 p-2 bg-primary-1--hover",
              on: {
                click: function($event) {
                  return _vm.$emit("selected", item)
                }
              }
            },
            [
              item.icon
                ? _c("em", { staticClass: "mr-1", class: item.icon })
                : _vm._e(),
              _vm._v(" " + _vm._s(item.label) + " ")
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex mr-n1" }, [
      _c("button", { staticClass: "input-group-text bg-orange text-white" }, [
        _c("em", { staticClass: "fas fa-search pl-2 pr-2" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }